import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import React, { useContext } from 'react'
import MatchSquares, { _msTypes } from './MatchSquares'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import FullPageWrapper from 'global/wrappers/FullPageWrapper'

const MatchLookup = (props) => {

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { matches_info } = sportsSeason_state ?? {}
  const { matches_combined } = matches_info ?? {}

  const handleCancel = () => {
    sportsSeason_handlers.handleShow_sportsElem()
    if (props.handleCancel) {
      props.handleCancel()
    }
  }

  const wrapper = () => <Wrapper
    content={<MatchSquares matches={matches_combined} msType={_msTypes.base} fromLookup={false} />}
    wrapperType={wrapperTypes.padded}
    noMid={true}
    css={{ container: 'app-dark-mode' }}
  />

  const fpw_matchList = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleCancel}
    topperCaption={'Match Lookup'}
  ></FullPageWrapper>

  return (
    wrapper()
  )
}

export default MatchLookup